import { BaseCachePayload } from 'src/app/cache/base-cache.payload';

export class ClientCachePayload extends BaseCachePayload {}
